import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Modal from "@mui/material/Modal";
import Select from "@mui/material/Select";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../Axios.jsx";
import { StudentExeProgressCards } from "../../components/StudentExeProgressCards/StudentExeProgressCards.jsx";
import useAuth from "../../contexts/UserContext.tsx";
import {
  addCourse,
  addCourseName,
  selectCourse,
} from "../../features/student/studentSlice.js";
import { toast } from "sonner";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 950,
  overflow: "scroll",
  height: "95vh",
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
};

export const StudentExerciseProgress = () => {
  const dispatch = useDispatch();
  const crs = useSelector(selectCourse);

  const { id } = useParams();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [schoolCourses, setSchoolCourses] = useState();
  const [course, setCourse] = useState();
  const [exerciseProgress, setExerciseProgress] = useState();
  const [, setExerciseItems] = useState();
  const [loading, setLoading] = useState(false);
  const [school, setSchool] = useState("");
  const showBack = user.view_access_list.isIndividualSchool;

  const [studentExerciseStatus, setStudentExerciseStatus] = useState();
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  // Accordion
  const [, setExpandedAccordion] = useState(false);

  const getSchoolNameByID = async () => {
    await axiosInstance
      .post("getSchoolNameByID", {
        school_id: id,
        user_id: user.user_id,
        auth_token: user.auth_token,
      })
      .then((res) => {
        if (res.data.data.message === "Invalid User") {
          toast.error("Invalid User");
          logout();
          return;
        }
        setSchool(res.data.data.school_name[0].school_name);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getCourses = async () => {
    try {
      const res = await axiosInstance.post("/getCourseForSchools", {
        auth_token: user.auth_token,
        school_id: id,
      });
      setSchoolCourses(res.data.data.crs_details);

      if (crs) {
        setCourse(crs);
        handleSubmitCourseSelected(crs);
        return;
      } else {
        dispatch(addCourse(res.data.data.crs_details[0].crs_id));
        dispatch(addCourseName(res.data.data.crs_details[0].crs_title));

        setCourse(res.data.data.crs_details[0].crs_id);
        handleSubmitCourseSelected(res.data.data.crs_details[0].crs_id);
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleSubmitCourseSelected = async (selected_course) => {
    try {
      dispatch(addCourse(selected_course));
      setLoading(true);
      const res = await axiosInstance.post("/getExerciseProgressForSchool", {
        auth_token: user.auth_token,
        school_id: id,
        crs_id: selected_course,
      });
      setExerciseProgress(res.data.data.exercise_progress_for_school);
      setExerciseItems(
        res.data.data.exercise_progress_for_school.progess_by_chapter
      );
      setExpandedAccordion(
        res.data.data.exercise_progress_for_school.progess_by_chapter[0].sec_id
      );
      console.log(
        "student exercise progress",
        res.data.data.exercise_progress_for_school.progess_by_chapter
      );
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const getStudentStatusExercise = async (item_id) => {
    try {
      const res = await axiosInstance.post("/getStudentStatusExercise", {
        auth_token: user.auth_token,
        school_id: id,
        excs_id: item_id,
      });
      setStudentExerciseStatus(res.data.data.crs_details[0]);
      handleOpenModal();
    } catch (err) {
      console.error(err.message);
    }
  };


  useEffect(() => {
    getCourses();
    getSchoolNameByID();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="student-exercise-progress-container pl-4 pr-4">
      {schoolCourses && (
        <>
          <div className="school-name-container flex items-center gap-2">
            {!showBack && (
              <ArrowBackIcon
                className="back-btn hover:cursor-pointer"
                onClick={() => navigate(-1)}
              />
            )}
            <span className="school-name text-[35px] font-bold">{school}</span>
          </div>
          <div className="course-container flex gap-4 mt-4">
            <Box sx={{ width: "100vw" }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Course</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={course}
                  label="Course"
                  onChange={(e) => setCourse(e.target.value)}
                >
                  {schoolCourses.map((course, index) => (
                    <MenuItem key={course.crs_id} value={course.crs_id}>
                      {course.crs_title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <button
              className="course-select-submit-btn bg-blue-500 rounded-md hover:bg-blue-700 w-[100px] text-white"
              onClick={() => handleSubmitCourseSelected(course)}
            >
              Submit
            </button>
          </div>
        </>
      )}

      {loading ? (
        <div className="flex justify-center items-center h-[500px]">
          <Typography variant="h5" className="text-gray-400">
            Loading...
          </Typography>
        </div>
      ) : (
        exerciseProgress && (
          <div className="exercise-accordion-container mt-5">
            <div className="flex justify-between items-center p-2">
              <Typography variant="h5" className="text-gray-400 mb-2">
                Skill Progress
              </Typography>
              <div className="flex gap-10">
                <div className="rounded-md flex items-center justify-center text-white p-2 bg-[#eab80f]">
                  <p className="text-white text-lg font-bold">Not Started</p>
                </div>
                <div className="rounded-md flex items-center justify-center text-white p-2 bg-[rgb(15,158,234)]">
                  <p className="text-white text-lg font-bold">Started</p>
                </div>
                <div className="rounded-md flex items-center justify-center text-white p-2 bg-[#ea271a]">
                  <p className="text-white text-lg font-bold">Struggling</p>
                </div>
                <div className="rounded-md flex items-center justify-center text-white p-2 bg-[#1b9808]">
                  <p className="text-white text-lg font-bold">Completed</p>
                </div>
              </div>
            </div>

            <StudentExeProgressCards
              id={id}
              data={exerciseProgress.progess_by_chapter}
            />

            {/* {
                exerciseProgress.progess_by_chapter.map((item)=> (
                  <Accordion 
                    key={item.sec_id}
                    expanded={expandedAccordion === item.sec_id}
                    onChange={handleAccordionExpandChange(item.sec_id)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`${item.sec_id}bh-content`}
                      id={`${item.sec_id}bh-header`}
                      sx={{ backgroundColor: expandedAccordion === item.sec_id ? "rgb(226 232 240)" : "#fff" }}
                    >
                      <Typography sx={{ width: '33%', flexShrink: 0, textDecoration: expandedAccordion === item.sec_id ? "underline" : "none", fontWeight: "bold"}}>{item.sec_name}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div className="flex flex-col gap-2">
                        {
                          item.items.map((it)=> (
                            <>
                              <div
                                // style={{backgroundColor: "#50B7C7"}} 
                                key={it.item_id}
                                className="grid grid-cols-3 bg-slate-100 gap-10 p-2 rounded-md"
                              >
                                <div className="flex items-center">
                                  <span
                                    className="hover:cursor-pointer hover:underline hover:text-[#8884d8]"
                                    onClick={()=> getStudentStatusExercise(it.item_id)}
                                  >{it.item_title}</span>
                                </div>
                                <div className="flex gap-4">
                                  <div className="rounded-xl w-9 h-9 flex items-center justify-center text-white bg-[#eab80f]">
                                    {it.NotStarted}
                                  </div>
                                  <div className="rounded-xl w-9 h-9 flex items-center justify-center text-white bg-[rgb(15,158,234)]">
                                    {it.Started}
                                  </div>
                                  <div className="rounded-xl w-9 h-9 flex items-center justify-center text-white bg-[#ea271a]">
                                    {it.Struggling}
                                  </div>
                                  <div className="rounded-xl w-9 h-9 flex items-center justify-center text-white bg-[#1b9808]">
                                    {it.Completed}
                                  </div>
                                </div>
                              </div>
                            </>
                          ))
                        }
                      </div>
                    </AccordionDetails>
                  </Accordion>
                ))
              } */}
          </div>
        )
      )}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            List of Students and Exercise status
          </Typography>
          <div className="mt-5 grid grid-cols-4 gap-3">
            <div className="not-started-container">
              <div className="flex items-center justify-center text-white bg-[#eab80f] p-2 rounded-md">
                <p className="text-white text-lg font-bold">Not Started</p>
              </div>
              {studentExerciseStatus &&
                (studentExerciseStatus.NOTSTARTED[0] === "" ? (
                  <div className="flex items-center p-2 justify-center rounded-md gap-2 mt-2">
                    <p className="text-sm">No Students</p>
                  </div>
                ) : (
                  <>
                    {studentExerciseStatus.NOTSTARTED.map((item) => (
                      <div className="flex items-center p-2 justify-center bg-slate-200 rounded-md gap-2 mt-2">
                        <p className="text-sm">{item}</p>
                      </div>
                    ))}
                  </>
                ))}
            </div>

            <div className="started-container">
              <div className="flex items-center justify-center text-white bg-[rgb(15,158,234)] p-2 rounded-md">
                <p className="text-white text-lg font-bold">Started</p>
              </div>
              {studentExerciseStatus &&
                (studentExerciseStatus.STARTED[0] === "" ? (
                  <div className="flex items-center p-2 justify-center rounded-md gap-2 mt-2">
                    <p className="text-sm">No Students</p>
                  </div>
                ) : (
                  <>
                    {studentExerciseStatus.STARTED.map((item) => (
                      <div className="flex items-center p-2 justify-center bg-slate-200 rounded-md gap-2 mt-2">
                        <p className="text-sm">{item}</p>
                      </div>
                    ))}
                  </>
                ))}
            </div>

            <div className="struggling-container">
              <div className="flex items-center justify-center text-white bg-[#ea271a] p-2 rounded-md">
                <p className="text-white text-lg font-bold">Struggling</p>
              </div>
              {studentExerciseStatus &&
                (studentExerciseStatus.STRUGGLING[0] === "" ? (
                  <div className="flex items-center p-2 justify-center rounded-md gap-2 mt-2">
                    <p className="text-sm">No Students</p>
                  </div>
                ) : (
                  <>
                    {studentExerciseStatus.STRUGGLING.map((item) => (
                      <div className="flex items-center p-2 justify-center bg-slate-200 rounded-md gap-2 mt-2">
                        <p className="text-sm">{item}</p>
                      </div>
                    ))}
                  </>
                ))}
            </div>

            <div className="completed-container">
              <div className="flex items-center justify-center text-white bg-[#1b9808] p-2 rounded-md">
                <p className="text-white text-lg font-bold">Completed</p>
              </div>
              {studentExerciseStatus &&
                (studentExerciseStatus.Completed[0] === "" ? (
                  <div className="flex items-center p-2 justify-center rounded-md gap-2 mt-2">
                    <p className="text-sm">No Students</p>
                  </div>
                ) : (
                  <>
                    {studentExerciseStatus.Completed.map((item) => (
                      <div className="flex items-center p-2 justify-center bg-slate-200 rounded-md gap-2 mt-2">
                        <p className="text-sm">{item}</p>
                      </div>
                    ))}
                  </>
                ))}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};
